import React from "react";

import { Logo } from "~/components/logo";

export const LoadingScreen: React.FC = () => (
	<div className="animation-duration-1000 fixed inset-0 flex animate-fade-in flex-col items-center justify-center bg-white">
		<Logo size="lg" variant="gecko-only" />

		<div className="relative mt-4 inline-block text-base text-graphite-600">Loading&hellip;</div>
	</div>
);
